module.exports = __webpack_public_path__ + "static/media/partner_5_logo.b02d2c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner_5_logo.png
// module id = 1216
// module chunks = 0